import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=a957edb0&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=a957edb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a957edb0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogChip: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/chip.vue').default})
